import React from 'react';
import { connect } from 'react-redux';
import UploadContainer from './upload-container';

export const types = {
    CYCLE_COACH : { type: 'CYCLE_COACH', name: 'RELATÓRIO DO CICLO COMPLETO DE SESSÕES FORMAÇÃO COACHING/COACH*' },
    CYCLE_COACHEE: { type: 'CYCLE_COACHEE', name: 'RELATÓRIO DO CICLO COMPLETO DE SESSÕES FORMAÇÃO COACHING/COACHEE*' },
    CYCLE_MASTER:{ type:  'CYCLE_MASTER', name: 'RELATÓRIO DO CICLO COMPLETO DE SESSÕES DE MASTER COACHING/COACH*' },
};

const renderTab = [types.CYCLE_COACH, types.CYCLE_COACHEE, types.CYCLE_MASTER];

class Upload extends React.Component {

    state = {
        currentIndex: undefined,
        haveFiles: {},
        currentType: '',
    };

    updateHaveFiles = () => {
        const { currentTccs } = this.props;

        if (currentTccs && currentTccs.attachments) {
            const newHaveFiles = {};
            for (const { type } of renderTab) {
                const current = currentTccs.attachments.find(e=>e.type === type);
                newHaveFiles[type] = current;
            }
            this.setState({ ...this.state, haveFiles: newHaveFiles });
        }
    }

    componentDidMount() {
        this.updateHaveFiles();
    }

    componentDidUpdate(prevProps) {
        const { currentTccs } = this.props;

        if (currentTccs !== prevProps.currentTccs) {
            this.updateHaveFiles();
        }

    }

    renderItems = () => {
        const { currentIndex, haveFiles, currentType } = this.state;
        const { tests, currentTccs = {}, readOnly } = this.props;

        let renderItems = [];
        let count = 1;
        let currentRenderTab = (tests && tests.length === 1) && tests[0] === 'MASTER' ? [...renderTab.slice(2, 6)] : [...renderTab];
        for (let i = 0; i < currentRenderTab.length;i++) {
            if (currentRenderTab[i].type === types.CYCLE_MASTER.type && !tests.includes('MASTER')) {
                continue;
            }
            renderItems.push((
                <div key={i} className='content-item section-header' >
                    <div className='container-text' onClick={()=> this.setState({ ...this.state, currentIndex:  currentIndex === i ? undefined : i, currentType: currentRenderTab[i].type })}>
                        <span >{ count++ }.</span>
                        { haveFiles[currentRenderTab[i].type] && <i className='fa fa-check-circle '></i>}
                        <span className='panel-custom-header accordion-input ' >{currentRenderTab[i].name}</span>
                        <div><i className={`accordion-arrow fa ${currentIndex === i ? 'fa-angle-up' : 'fa-angle-down'}`}></i></div>
                    </div>
                    { currentIndex === i && <UploadContainer readOnly={readOnly} currentType={currentType} files={currentTccs.attachments && currentTccs.attachments.filter(e=>e.type === currentType)} />}
                </div>
            ));
        }

        return renderItems;
    }

    render() {
        return (
            <div className='content-new-upload' >
                { this.renderItems() }
            </div>
        );
    }
}

const mapStateToProps = ({ App })=> {
    return {
        currentClasse: App.currentClasse,
        classesNewEad: App.classesNewEad,
        currentTccs: App.currentTccs,
    };
};

export default connect(mapStateToProps, {})(Upload);



// WEBPACK FOOTER //
// ./src/components/section/components/upload-new-ead.js